import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseInfiniteQueryResult } from 'react-query'
import { Response } from 'request-dot-js'

export function collectResults<ResponseType, Item>(
  query: UseInfiniteQueryResult<Response<ResponseType>>,
  extractor: (data: ResponseType) => Item[],
) {
  return (query.data?.pages || []).flatMap((page) => (page.type === 'success' ? extractor(page.data) : []))
}

export const getTotalCountFromInfiniteQuery = <T>(query: UseInfiniteQueryResult<Response<T>>) => {
  if (query.data?.pages[0].type !== SUCCESS_RESPONSE_TYPE) return 0
  return Number(query.data?.pages[0].headers['total-count'] ?? 0)
}
